<template>
  <div class="h-[40px] w-[48px] flex flex-col bg-[#0B1426] rounded-lg">
    <div class="h-1/2 flex items-start justify-center">
      <span class="text-white text-lg font-bold"> {{ value }}</span>

    </div>
  <div class="h-1/2 flex items-center justify-center">

    <span class="text-white text-[9px] font-bold"> {{ label }}</span>
  </div>
  </div>
</template>

<script setup>
defineProps({
    value: {
        type: Number,
        required: true
    },
    label: {
        type: String,
        required: true
    }
});
</script>